import {
  fetchSettingsNotifications,
  saveSettingsNotifications
} from '@/api/user'

/**
* Fetch user behavior from API
*/
const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('FETCH_USER_NOTIFICATIONS_SUBMIT')

    fetchSettingsNotifications()
      .then((response) => {
        if (response) {
          commit('FETCH_USER_NOTIFICATIONS_RESPONSE', response)
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('FETCH_USER_NOTIFICATIONS_ERROR_RESPONSE', error)
        reject(error)
      })
      .finally(() => {
      })
  })
}

/**
* Set number as users primary
*/
const set = async ({ commit }, notifications) => {
  return new Promise((resolve, reject) => {
    commit('SET_USER_NOTIFICATIONS_SUBMIT')

    saveSettingsNotifications(notifications)
      .then((response) => {
        if (response) {
          commit('SET_USER_NOTIFICATIONS_SUCCESS')
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('SET_USER_NOTIFICATIONS_ERROR_RESPONSE')
        reject(error)
      })
      .finally(() => {
      })
  })
}

export default {
  fetch,
  set
}



// WEBPACK FOOTER //
// ./src/store/modules/user/notifications/actions.js